import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M12 2.5H4C3.17157 2.5 2.5 3.17157 2.5 4V9C2.5 9.82843 3.17157 10.5 4 10.5H6L8 13.5L10 10.5H12C12.8284 10.5 13.5 9.82843 13.5 9V4C13.5 3.17157 12.8284 2.5 12 2.5Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Icon;
